import { render, staticRenderFns } from "./ListItem1Template.vue?vue&type=template&id=b8a28376"
import script from "./ListItem1Template.vue?vue&type=script&lang=js"
export * from "./ListItem1Template.vue?vue&type=script&lang=js"
import style0 from "./ListItem1Template.vue?vue&type=style&index=0&id=b8a28376&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports